import { render, staticRenderFns } from "./StageCommentItem.vue?vue&type=template&id=e3d310a2&scoped=true&"
import script from "./StageCommentItem.vue?vue&type=script&lang=js&"
export * from "./StageCommentItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=e3d310a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d310a2",
  null
  
)

export default component.exports